import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Fuse from 'fuse.js';
import React from 'react';
import { connect } from 'react-redux';

const PropertiesSearchDialog = ({ open, onClose, onPropertyClick = () => null, properties }) => {
  const [database] = React.useState(() => {
    return new Fuse(
      properties,
      {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ['displayName', 'place.formattedAddress']
      }
    );
  });
  const [state, setState] = React.useState({ query: '', results: [] });

  const queryDatabase = event => {
    const query = event.target.value;
    setState({ query, results: database.search(query).slice(0, 10) });
  };
  const resetState = () => {
    setState({ query: '', results: [] });
  };

  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm' onExited={resetState}>
      <div className={classes.inputContainer}>
        <TextField
          value={state.query}
          onChange={queryDatabase}
          autoFocus
          fullWidth
          placeholder='Search properties'
          type='search'
          variant='outlined'
        />
      </div>
      <DialogContent className={classes.results}>
        <List>
          {state.results.map(property => (
            <ListItem
              key={property.propertyId}
              button
              onClick={() => {
                onPropertyClick(property.propertyId);
                onClose();
              }}
            >
              <ListItemText
                primary={property.displayName}
                secondary={property.place.formattedAddress}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  inputContainer: {
    margin: theme.spacing(2)
  },
  results: {
    padding: 0
  }
}));

const mapStateToProps = (state, ownProps) => {
  const division = state.divisions.byId[ownProps.divisionId];
  if (division !== undefined) {
    return {
      properties: Object.keys(division.properties.byId)
        .filter(propertyId => {
          const property = state.properties.byId[propertyId];
          return !division.properties.byId[propertyId].isDeleted && property !== undefined && !property.isDeleted;
        })
        .map(propertyId => state.properties.byId[propertyId])
    };
  } else {
    return {
      properties: Object.values(state.properties.byId).filter(property => !property.isDeleted)
    };
  }
};

export default connect(mapStateToProps)(PropertiesSearchDialog);